import { render, staticRenderFns } from "./drug.vue?vue&type=template&id=1d5ab8bc&"
import script from "./drug.vue?vue&type=script&lang=js&"
export * from "./drug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports